// enum for environment variables in configuration file .env
export enum EnvVar {
    REACT_APP_ZDIELANIE_KLIENTOV = 'REACT_APP_ZDIELANIE_KLIENTOV',
}

// enum for values of the environment variable REACT_APP_ZDIELANIE_KLIENTOV
export enum ReactAppZdielanieKlientov {
    ZAKLADNE_UDAJE = 'ZAKLADNE_UDAJE',
    VSETKY_UDAJE = 'VSETKY_UDAJE',
    ZIADNE_UDAJE = 'ZIADNE_UDAJE'
}
